import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Shows the element as nav-bar button in the native app; a tap clicks the real link.
// When the element leaves the page the app is told, so the button does not outlive it.
export default class extends BridgeComponent {
  static component = "button"

  connect() {
    super.connect()

    this.send("connect", this.payload(), () => this.bridgeElement.click())
  }

  disconnect() {
    this.send("disconnect", this.payload())
    super.disconnect()
  }

  payload() {
    const title = this.bridgeElement.title
    const slot = this.bridgeElement.bridgeAttribute("slot")
    const icon = this.bridgeElement.bridgeAttribute("icon")
    const badge = this.bridgeElement.bridgeAttribute("badge")
    // Optional neutral color name, e.g. "danger"
    const tint = this.bridgeElement.bridgeAttribute("tint") || undefined
    // Optional count shown on the button, e.g. the number of active filters
    return { title, slot, icon, tint, badge: badge == null ? undefined : parseInt(badge, 10) || 0 }
  }
}
